import {
  Commission,
  Product,
  ProductCategory,
  TAutoCompleteOptions,
  TGetProductCommissionParams,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const ProductService = emptySplitApi.injectEndpoints(
  {
    endpoints: (build) => ({
      getMeasurementUnits: build.query<
        TAutoCompleteOptions[],
        void
      >({
        query: () => ({
          url: 'products/measurementUnits',
          method: 'GET',
        }),
        transformResponse: (data: string[]) => {
          const listOfData = data.map((unit) => ({
            value: unit,
            label: unit,
          }));
          return listOfData;
        },
      }),
      getProductCategories: build.query<
        ProductCategory[],
        void
      >({
        query: () => ({
          url: 'product-categories',
          method: 'GET',
        }),
      }),
      getProductDetailsById: build.query<Product, string>({
        query: (id) => ({
          url: `product/${id}`,
          method: 'GET',
        }),
      }),
      getProductCommissions: build.query<
        { data: Commission[]; totalCount: number },
        TGetProductCommissionParams
      >({
        query: (params) => ({
          url: 'product-commissions',
          method: 'GET',
          params,
        }),
        transformResponse: (
          data: Commission[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
      }),
    }),
  }
);

export const {
  useGetMeasurementUnitsQuery,
  useGetProductCategoriesQuery,
  useGetProductDetailsByIdQuery,
  useGetProductCommissionsQuery,
} = ProductService;
